"use strict";
/**
 * @module Services.ControlClient
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Data type for a FILTER_SUBSCRIBE and FILTER_UNSUBSCRIBE request.
 */
var ClientFilterSubscribeRequest = /** @class */ (function () {
    /**
     * Create a new ClientFilterSubscribeRequest instance
     *
     * @param filter  the filter
     * @param selector  the topic selector
     */
    function ClientFilterSubscribeRequest(filter, selector) {
        this.filter = filter;
        this.selector = selector;
    }
    return ClientFilterSubscribeRequest;
}());
exports.ClientFilterSubscribeRequest = ClientFilterSubscribeRequest;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/control-client/client-filter-subscribe-request.js
// module id = 1179
// module chunks = 1